module.exports = __webpack_public_path__ + "static/FirebaseConfig-6aad7cc498f00ac310e46748b2724a44.png";